import { useConnect } from '@lore/query-connect';

export default function useQuestions(state, network, schoolStart, schoolEnd, extra = {}) {
  return useConnect('question.find', {
    where: {
      eager: {
        $where: {
          // ...project_networkId(network),
          project: {
            $where: {
              site: {
                $where: {
                  state: {
                    $ilike: state
                  }
                }
              }
            }
          },
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          },
          request: { $not: 'Outreach' },
          ...extra
        }
      }
    },
    pagination: {
      pageSize: 1
    }
  });
}
